import SEO from '../../seo'

const SpFavicons = () => {
    return (
        <SEO
            title="Install Startpage - Private AI App"
            description="AI search without tracking or profiling on Startpage - Private AI"
            ogImagePath="https://www.startpage.com/sp/cdn/images/privateai/privateai-icon.png"
            ogUrl="https://privateai.startpage.com"
            favicons={[
                {
                    rel: `icon`,
                    type: `image/x-icon`,
                    sizes: `16x16`,
                    href: `https://www.startpage.com/sp/cdn/images/privateai/favicon.ico`,
                },
                {
                    rel: `icon`,
                    type: `image/png`,
                    sizes: `16x16`,
                    href: `https://www.startpage.com/sp/cdn/images/privateai/favicon-16x16.png`,
                },
                {
                    rel: `icon`,
                    type: `image/png`,
                    sizes: `32x32`,
                    href: `https://www.startpage.com/sp/cdn/images/privateai/favicon-32x32.png`,
                },
                {
                    rel: `icon`,
                    type: `image/png`,
                    sizes: `192x192`,
                    href: `https://www.startpage.com/sp/cdn/images/privateai/android-icon-192x192.png`,
                },
                {
                    rel: `icon`,
                    type: `image/png`,
                    sizes: `512x512`,
                    href: `https://www.startpage.com/sp/cdn/images/privateai/512.png`,
                },
                {
                    rel: 'apple-touch-icon',
                    type: `image/png`,
                    sizes: `180x180`,
                    href: `https://www.startpage.com/sp/cdn/images/privateai/apple-icon.png`,
                },
            ]}
        />
    )
}

export default SpFavicons
